import React from 'react'

export default function ArchivedGroupsRepository() {
  return (
    <div>ArchivedGroupsRepository</div>
  )
}
